export const event = ({ detail }) => new CustomEvent("iframe-resize", { detail });
export const events = { event };
